/// <reference path="../../_ext/editors/ItemGridEditor.ts" />

namespace TabAurous.Purchase {

    import fld = ApprovalInItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ApprovalInItemsEditor extends _Ext.ItemGridEditor<ApprovalInItemsRow> {


        protected getColumnsKey() { return "Purchase.ApprovalInItems"; }
        protected getDialogType() { return ApprovalInItemsDialog; }
        protected getLocalTextPrefix() { return ApprovalInItemsRow.localTextPrefix; }
        protected form: ApprovalInItemsForm;

        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = false; 
            return opt;
        }

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables 
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
        public DeptId: number;
        private GenSKU: boolean = false;   
        isEditable: boolean;

        // #endregion

        // #region Constructor
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true, rowHeight: 30 });
            this.toolbar.findButton('add-button').find('.button-inner').text('New Product');
             
            Q.reloadLookup(OMS.DepartmentMasterRow.lookupKey);
            var value = q.ToBool(GetConfigValue(1004)); 
            if (value == true)
                this.GenSKU = true;
            else
                this.GenSKU = false;

            this.isEditable = this.slickGrid.getOptions().editable;


            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as Purchase.ApprovalInDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);
                }
            });

            this.slickGrid.onRender.subscribe(() => {
                // call of the function that will bind the editors with the fields (<input>) of the html page
                this.SetInlineLookupEditor();
            });
        }
        // #endregion

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this); 

            var Department = Q.first(columns, x => x.field === fld.DepartmentId);
            Department.referencedFields = [fld.DepartmentId];
            Department.format = ctx => {
                var width = (ctx.column.width) as number - 10;
                return '<input type="hidden" style="text-align: right; width:' + width + 'px;" id="LocId' + ctx.row + '" title="Location" />';
            };
            //Department.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.DepartmentId, OMS.DepartmentMasterRow.getLookup(), this);

            Q.first(columns, x => x.field === fld.Pieces).format = int;
            Q.first(columns, x => x.field === fld.Weight).format = wt;
            Q.first(columns, x => x.field === fld.DiscountPer).format = num;
            Q.first(columns, x => x.field === fld.Discount).format = amt;
            Q.first(columns, x => x.field === fld.UnitRate).format = amt;

            if (!this.GenSKU)
                columns = columns.filter(x => x.field != 'SKU');

            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion



        public SetInlineLookupEditor() {
            // course of all the lines present in the grid
            var Items = this.view.getItems();
            if (Items.length > 0)
                for (let Item in Items) {
                    this.InlineLookup(Item, Items);
                }
        }

        private InlineLookup(RowIndex: string, Items: PurchaseItemsRow[]) {

            var select = $("#LocId" + RowIndex);

            if (!select.hasClass("select2-offscreen")) {

                let opt: Serenity.LookupEditorOptions = {
                    lookupKey: OMS.DepartmentMasterRow.lookupKey
                };
                var Editor = new TabAurous.InlineLookupEditor($("#LocId" + RowIndex), opt);
                if (this.isReadOnly == true) {
                    q.showAndDisableField(Editor);
                }

                Editor.value = Q.toId(Items[RowIndex].DepartmentId);
                Editor.changeSelect2(e => {
                    Items[RowIndex].DepartmentId = Q.toId(Editor.value);
                });
            }
            else {
                if (this.isReadOnly == false) {
                    select.closest('.slick-cell').find('.select2-container-disabled').removeClass('select2-container-disabled');
                    select.removeClass('readonly');
                }
            }
        }

        // #region Common Functions
 
        setMasterValues() {
            this.RateListId = (this.parentDialog as ApprovalInDialog).RateListId;
            this.LaborListId = (this.parentDialog as ApprovalInDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as ApprovalInDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as ApprovalInDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as ApprovalInDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as ApprovalInDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as ApprovalInDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as ApprovalInDialog).form.TransDate.valueAsDate;
            this.PartyId = parseInt((this.parentDialog as ApprovalInDialog).form.PartyId.value);
        }

        public Editable() {
            this.isEditable = true;
        }

          

        // **** to Call shortcut key in Main Window
        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }

        // #endregion

        //#region  ItemGrid Inline Editor

       
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight || field === fld.Discount || field === fld.UnitRate) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0 && item.ItemTypeId == 101) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.NetAmount * value;
                    item.Weight = (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                }
                item[field] = value;
                item.LaborDetails.forEach(function (labor) {
                    labor.Pieces = value;
                })
            }
            // **** Allow to Set Pcs to Zero for RM ****
            if (field === fld.Pieces && item.ItemTypeId != 101) {
                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = ((item.UnitRate + labr) / item.Pieces) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }
                item.LaborDetails.forEach(function (labor) {
                    labor.Pieces = value;
                })

            }

            // **** Allow to Set Weight for RM ****
            if (field === fld.Weight && !item.HasBom) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var rate = item.UnitRate || 0;
                    if (item.ItemTypeId == 101 || item.ItemTypeId == 104) {
                        rate = item.UnitRate * item.Purity;
                    }

                    var Net = (rate + labr) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.NetWeight = value;
                    if (item.WstPer != null) {
                        item.WstWt = value * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

                item.LaborDetails.forEach(function (labor) {
                    labor.Weight = value;
                })
            }

            // **** Calculate Amount based on UnitRate and Weight or Pieces
            if (field === fld.UnitRate && item.ItemTypeId != 101) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Weight * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;
                }


                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Pieces * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;
                }
                item[field] = value;
            }

            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item.DiscountPer = (value / item.NetAmount) * 100;
                item[field] = value;
            }

            // *** Calculate Discount % ***
            if (field === fld.DiscountPer && value >= 0) {
                var Discount = (item.NetAmount * value) / 100
                item.GrossAmount = item.NetAmount - Discount;
                item.Discount = Discount;
                item[field] = value;
            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;
            }
            item.UnitCost = item.CalcOnId == 3 ? (item.UnitRate + item.UnitLabour) / item.Pieces : (item.UnitRate + item.UnitLabour) / item.Weight;
            item.CCGrossAmount = item.GrossAmount * this.ExchangeRate;
            item.CCNetAmount = item.NetAmount * this.ExchangeRate;
            this.view.updateItem(id, item);

            this.view.refresh();
            (this.parentDialog as ApprovalInDialog).CalculateAmountandTax(this.view.getItems(), this.view.getItems().length);

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion

        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons(); 
            buttons.filter(x => x.cssClass == "add-button")[0].visible = false; 
            var addbutton = buttons.filter(x => x.cssClass == "add-button")[0];
            buttons.push({
                title: "New Product",
                cssClass: "add-button",
                hotkey: "alt+n",
                hint: 'alt+n',
                onClick: () => { 
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (this.PartyId == 0 || this.PartyId == null || isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {

                        addbutton.onClick();
                    }  

                }
            });
            //**** Master ****//
            buttons.push({
                title: "Select Items",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {
                    var grid = Common.ProductSelectGrid;
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (this.PartyId == 0 || this.PartyId == null) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {
                        var filters: _Ext.SelectGridFilters = {
                            
                        } 
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters:filters 
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        //let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.AttributeId == t.AttributeId) });

                        let selectedItems2 = selectedItems;
                        var ItemDetails = ItemGridHelper.SetPurchaseItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup, this.GenSKU, true);
                        this.setData(ItemDetails);
                    }
                     
                    pickerDialog.dialogOpen();
                },
                disabled: () => this.isReadOnly || this.readOnly
            });            
            
            //**** Sales Order ****//
            buttons.push({
                title: "Select SO",
                cssClass: "order-button",
                hotkey: "alt+i",
                hint: 'alt+i',
                onClick: () => {
                    var grid = SalesOrder.OrderItemsGrid;
                    this.setMasterValues();
                    // **** Validate Party before Item Selection ****
                    if (this.PartyId == 0 || this.PartyId == null) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {
                        var filters: _Ext.SelectGridFilters = {
                            PartyId: this.PartyId,
                            InStock: false
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var ItemDetails = ItemGridHelper.SetPurchaseItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup, this.GenSKU, false);
                        this.setData(ItemDetails);

                    }

                    pickerDialog.element.bind('dialogclose', () => {

                        this.element.trigger('dialogclose');

                    });
                    pickerDialog.dialogOpen();
                }
            }); 
            return buttons;
        }
        // #endregion

        // #region Set Data

        setData(ItemDetails: any[]) { 
            for (let Itemdetail of ItemDetails) {
                Itemdetail.RefTransId = Itemdetail.RefTransId == null? 0 : Itemdetail.RefTransId;
                Itemdetail.RefTransItemId = Itemdetail.RefTransItemId == null? 0 : Itemdetail.RefTransItemId;
                Itemdetail.RefVoucherId = Itemdetail.RefVoucherId == null? 0 : Itemdetail.RefVoucherId;

                Itemdetail[this.getIdProperty()] = "`" + this.nextId++;
              
                this.view.addItem(Itemdetail);
            }
        }

        // #endregion
    }
}